
import { Link } from "react-router-dom";

export default function ServicesCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-5xl font-bold mb-8 bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
          Ready to Scale Your Business?
        </h2>

        <div className="flex flex-wrap justify-center gap-6">
          <Link
            to="/enquiry"
            className="px-10 py-5 bg-dark text-white font-semibold rounded-full hover:bg-primary transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 text-lg whitespace-nowrap"
          >
            Schedule Consultation
          </Link>
        </div>

        <div className="pt-8 space-y-4">
          <div className="flex items-center justify-center gap-2 text-gray-700">
            <i className="ri-global-line text-xl"></i>
            <p className="text-base font-medium">
              We also provide services to USA, UK, UAE, and Qatar
            </p>
          </div>
          <p className="text-sm text-gray-600">
            <a href="mailto:growthlink2705@gmail.com" className="hover:text-primary transition-colors">
              growthlink2705@gmail.com
            </a>
            {" | "}
            <a href="https://wa.me/918931893177" className="hover:text-primary transition-colors">
              +91 8931893177
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
